"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var GetBucketNotificationInput_1 = require("./GetBucketNotificationInput");
var GetBucketNotificationOutput_1 = require("./GetBucketNotificationOutput");
var ServiceMetadata_1 = require("./ServiceMetadata");
exports.GetBucketNotification = {
    metadata: ServiceMetadata_1.ServiceMetadata,
    name: "GetBucketNotification",
    http: {
        method: "GET",
        requestUri: "/{Bucket}?notification"
    },
    input: {
        shape: GetBucketNotificationInput_1.GetBucketNotificationInput
    },
    output: {
        shape: GetBucketNotificationOutput_1.GetBucketNotificationOutput
    },
    errors: []
};
//# sourceMappingURL=GetBucketNotification.js.map